import { Meta } from "@/shared/components";
import { Users } from "@/admin/features/users";

export function UsersPage() {
  return (
    <>
      <Meta title="Пользователи" />
      <Users />
    </>
  );
}
